import { useState } from 'react';
import Select from 'components/shared/select';
import { useGlobalModules } from 'contexts';
import { getCartLineSellingPlans, getSellingPlanOptions } from 'lib/shopify/sellingPlans';
import styles from './subscriptionToggle.module.scss';

const SubscriptionToggle = ({ lineItem, onUpdateSellingPlan }) => {
  const globalModules = useGlobalModules();
  const [pending, setPending] = useState(false);
  const plans = getCartLineSellingPlans(lineItem);
  const activePlanId = lineItem.sellingPlanAllocation?.sellingPlan?.id || null;
  const hasSubscriptions = globalModules?.settings?.locale?.hasSubscriptions !== false;
  if (!plans.length || (!hasSubscriptions && !activePlanId)) return null;

  const { subscription, accessibility } = globalModules?.translations || {};
  const label = subscription?.cartToggleLabel || subscription?.ongoingSubscriptionsLabel || '';
  const toggleColor = globalModules?.colors?.subscription?.cartToggleColor || '';

  const update = async sellingPlanId => {
    setPending(true);
    try {
      await onUpdateSellingPlan(sellingPlanId);
    } finally {
      setPending(false);
    }
  };

  return (
    <div className={styles.container}>
      <span className={styles.label}>{label}</span>
      <div className={styles.controls}>
        <label className={styles.switch} htmlFor={`subscription-toggle-${lineItem.id}`}>
          <input
            id={`subscription-toggle-${lineItem.id}`}
            type="checkbox"
            checked={Boolean(activePlanId)}
            disabled={pending}
            onChange={() => update(activePlanId ? null : plans[0].id)}
            aria-label={label}
          />
          <span
            className={styles.slider}
            style={activePlanId && toggleColor ? { backgroundColor: toggleColor } : undefined}
          />
        </label>
        {activePlanId && (
          <Select
            className={styles.select}
            options={getSellingPlanOptions(plans)}
            selected={activePlanId}
            disabled={pending}
            onChange={update}
            ariaLabel={accessibility?.deliveryFrequency || 'Delivery frequency'}
          />
        )}
      </div>
    </div>
  );
};

export default SubscriptionToggle;
